import { RrsTemplateLabelCategory } from "server/models"
import { GET, POST, DELETE } from "client/store/utils"
import { RrsTemplateList } from "client/store"

export const LoadAllRrsTemplateLabelCategories = (labelId: number) => (
    GET(`/rrsTemplateLabelCategory/labelId/${labelId}`)
    .then((categories: RrsTemplateLabelCategory[]) => {
        const categoryIds: number[] = []
        categories.forEach((row) => {
            categoryIds.push(row.categoryId)
        })
        return categoryIds
    })
)

export const SelectParentRrsTemplateLabelCategories = (categoryIds: number[]) => (
    POST(
        "/rrsTemplateLabelCategory/selectParentTemplates",
        JSON.stringify(categoryIds),
    ).then((categories: RrsTemplateLabelCategory[]) => {
        const templates: RrsTemplateList = {}
        categories.forEach((row) => {
            if (row.label && row.label.template) templates[row.label.template.id] = row.label.template
        })
        return templates
    })
)

export const CreateRrsTemplateLabelCategories = (data: RrsTemplateLabelCategory[]) => (
    POST(
        "/rrsTemplateLabelCategory/create",
        JSON.stringify(data),
    )
)

export const DeleteRrsTemplateLabelCategoriesByLabel = (labelId: number) => ( // when change label category
    DELETE(`/rrsTemplateLabelCategory/deleteByLabel/${labelId}`)
    .then((removedRows: number) => removedRows)
)

export const DeleteRrsTemplateLabelCategory = (labelId: number, categoryId: number) => (
    DELETE(`/rrsTemplateLabelCategory/delete/${labelId}/${categoryId}`)
    .then((removedRows: number) => removedRows)
)
